// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (min-width: 950px) {
    .tenant-administrator-account-page{
        margin: 0px;
        padding: 0px;
        height: 100vh;
        position: relative;
        box-sizing: border-box;
        font-family:Verdana, Geneva, Tahoma, sans-serif;
    }
    .tenant-administrator-account-page-layout{
        height: 90%;
        box-sizing: border-box;
        display: grid;
        grid-template-columns: auto 1fr;
    }
    .tenant-administrator-account-navigation-bar{
        display: flex;
    }
    .tenant-administrator-account-navigation-bar button{
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 5px;
        width: 12vw;
        cursor: pointer;
        border: none;
        background-color: transparent;
    }
    .tenant-administrator-account-navigation-bar button.active{
        border-bottom: 2px solid brown;
    }
    .tenant-administrator-account-navigation-bar button img{
        height: 25px;
        margin-right: 10px;
    }
}
@media screen and (max-width: 949px) {
    .tenant-administrator-account-page{
        margin: 0px;
        padding: 0px;
        height: 100vh;
        position: relative;
        box-sizing: border-box;
        font-family:Verdana, Geneva, Tahoma, sans-serif;
    }
    .tenant-administrator-account-page-layout{
        height: 90%;
        box-sizing: border-box;
        display: grid;
        grid-template-columns: auto 1fr;
    }
    .tenant-administrator-account-navigation-bar{
        display: flex;
    }
    .tenant-administrator-account-navigation-bar button{
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 5px;
        width: 32vw;
        cursor: pointer;
        border: none;
        font-size: 12px;
        background-color: transparent;
    }
    .tenant-administrator-account-navigation-bar button.active{
        border-bottom: 2px solid brown;
    }
    .tenant-administrator-account-navigation-bar button img{
        height: 25px;
        margin-right: 10px;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/TenantAdministratorStyles/Accounts/Account.css"],"names":[],"mappings":"AAAA;IACI;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,kBAAkB;QAClB,sBAAsB;QACtB,+CAA+C;IACnD;IACA;QACI,WAAW;QACX,sBAAsB;QACtB,aAAa;QACb,+BAA+B;IACnC;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,YAAY;QACZ,WAAW;QACX,eAAe;QACf,YAAY;QACZ,6BAA6B;IACjC;IACA;QACI,8BAA8B;IAClC;IACA;QACI,YAAY;QACZ,kBAAkB;IACtB;AACJ;AACA;IACI;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,kBAAkB;QAClB,sBAAsB;QACtB,+CAA+C;IACnD;IACA;QACI,WAAW;QACX,sBAAsB;QACtB,aAAa;QACb,+BAA+B;IACnC;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,YAAY;QACZ,WAAW;QACX,eAAe;QACf,YAAY;QACZ,eAAe;QACf,6BAA6B;IACjC;IACA;QACI,8BAA8B;IAClC;IACA;QACI,YAAY;QACZ,kBAAkB;IACtB;AACJ","sourcesContent":["@media screen and (min-width: 950px) {\n    .tenant-administrator-account-page{\n        margin: 0px;\n        padding: 0px;\n        height: 100vh;\n        position: relative;\n        box-sizing: border-box;\n        font-family:Verdana, Geneva, Tahoma, sans-serif;\n    }\n    .tenant-administrator-account-page-layout{\n        height: 90%;\n        box-sizing: border-box;\n        display: grid;\n        grid-template-columns: auto 1fr;\n    }\n    .tenant-administrator-account-navigation-bar{\n        display: flex;\n    }\n    .tenant-administrator-account-navigation-bar button{\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        padding: 5px;\n        width: 12vw;\n        cursor: pointer;\n        border: none;\n        background-color: transparent;\n    }\n    .tenant-administrator-account-navigation-bar button.active{\n        border-bottom: 2px solid brown;\n    }\n    .tenant-administrator-account-navigation-bar button img{\n        height: 25px;\n        margin-right: 10px;\n    }\n}\n@media screen and (max-width: 949px) {\n    .tenant-administrator-account-page{\n        margin: 0px;\n        padding: 0px;\n        height: 100vh;\n        position: relative;\n        box-sizing: border-box;\n        font-family:Verdana, Geneva, Tahoma, sans-serif;\n    }\n    .tenant-administrator-account-page-layout{\n        height: 90%;\n        box-sizing: border-box;\n        display: grid;\n        grid-template-columns: auto 1fr;\n    }\n    .tenant-administrator-account-navigation-bar{\n        display: flex;\n    }\n    .tenant-administrator-account-navigation-bar button{\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        padding: 5px;\n        width: 32vw;\n        cursor: pointer;\n        border: none;\n        font-size: 12px;\n        background-color: transparent;\n    }\n    .tenant-administrator-account-navigation-bar button.active{\n        border-bottom: 2px solid brown;\n    }\n    .tenant-administrator-account-navigation-bar button img{\n        height: 25px;\n        margin-right: 10px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
